import React from 'react';

const urlItem = (path) => {
  return React.lazy(() => import(`../pages${path}`));
};

export default urlItem;
